import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { forgeProjectEntrypoint } from '@atlassian/jira-spa-apps-forge-project/entrypoint.tsx';

export const forgeProjectServicedeskPageEntrypoint = createPageEntryPoint({
	main: forgeProjectEntrypoint,
	topNavigationMenuId: MENU_ID.PROJECTS,
});
